import React from "react";
import { Reveal } from "../shared/Reveal";

const S = { fill: "none", stroke: "currentColor", strokeWidth: 1.8, strokeLinecap: "round", strokeLinejoin: "round" };

// Each statement paired with a themed icon so the section matches the rest of the page.
const STATEMENTS = [
  {
    text: "We work with some of the biggest brand names in the commercial and manufacturing sectors.",
    icon: <svg viewBox="0 0 24 24" width="22" height="22" {...S}><path d="M3 21h18" /><path d="M5 21V7l7-4 7 4v14" /><path d="M9 9h.01M9 13h.01M9 17h.01M15 9h.01M15 13h.01M15 17h.01" /></svg>,
  },
  {
    text: "Coupled with our global technology partners, we bring together decades of commercial energy experience.",
    icon: <svg viewBox="0 0 24 24" width="22" height="22" {...S}><circle cx="12" cy="12" r="9" /><path d="M3 12h18" /><path d="M12 3a15 15 0 0 1 0 18a15 15 0 0 1 0-18Z" /></svg>,
  },
  {
    text: "Our state-of-the-art technology is already deployed across 70 countries.",
    icon: <svg viewBox="0 0 24 24" width="22" height="22" {...S}><path d="M12 22s-8-4.5-8-11a8 8 0 0 1 16 0c0 6.5-8 11-8 11Z" /><circle cx="12" cy="11" r="2.6" /></svg>,
  },
  {
    text: "We identify exactly where, when and why energy is being wasted.",
    icon: <svg viewBox="0 0 24 24" width="22" height="22" {...S}><circle cx="11" cy="11" r="7" /><path d="m21 21-4.3-4.3" /></svg>,
  },
  {
    text: "We monitor individual circuits, machinery and critical assets — minute by minute.",
    icon: <svg viewBox="0 0 24 24" width="22" height="22" {...S}><path d="M3 12h4l3 8 4-16 3 8h4" /></svg>,
  },
  {
    text: "We expose energy losses hidden within compressors, HVAC, refrigeration, air conditioning, lighting, motors, pumps and production equipment.",
    icon: <svg viewBox="0 0 24 24" width="22" height="22" {...S}><circle cx="12" cy="12" r="3" /><path d="M12 2v3M12 19v3M2 12h3M19 12h3M4.9 4.9l2.1 2.1M17 17l2.1 2.1M19.1 4.9 17 7M7 17l-2.1 2.1" /></svg>,
  },
  {
    text: "We identify unnecessary consumption, out-of-hours operation, equipment inefficiency and damaging peak demand.",
    icon: <svg viewBox="0 0 24 24" width="22" height="22" {...S}><circle cx="12" cy="13" r="8" /><path d="M12 9v4l2.5 2.5M12 2h0M9 2h6" /></svg>,
  },
  {
    text: "Once the waste has been identified, intelligent alerts and continuous monitoring help prevent it from returning.",
    icon: <svg viewBox="0 0 24 24" width="22" height="22" {...S}><path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" /><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" /></svg>,
  },
  {
    text: "Every recommendation is supported by real operational evidence — not assumptions.",
    icon: <svg viewBox="0 0 24 24" width="22" height="22" {...S}><path d="M9 11l3 3 8-8" /><path d="M20 12v6a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h9" /></svg>,
  },
  {
    text: "We establish the facts before you invest in solar, batteries or replacement equipment.",
    icon: <svg viewBox="0 0 24 24" width="22" height="22" {...S}><path d="M4 10h3v10H4zM10.5 4h3v16h-3zM17 13h3v7h-3z" /></svg>,
  },
];

export default function WhatWeDo() {
  return (
    <section id="what" className="whatwedo">
      <div className="wrap">
        <Reveal className="eyebrow" tag="div">WHAT WE DO</Reveal>
        <Reveal className="wwd-exp" tag="p">
          We&rsquo;ve been in the energy industry for <span className="g">30 years</span> — installing every form of renewable energy.
        </Reveal>
        <Reveal className="h2" tag="div">Every Building Has an Energy Signature. <span className="g">Your Bill.</span></Reveal>
        <Reveal className="lead" tag="p">
          We unlock that bill — moving beyond the total cost to reveal, at a granular level, the individual
          assets, circuits and operating behaviours contributing to your energy <b>waste.</b>
        </Reveal>
        <div className="wwd-grid">
          {STATEMENTS.map((s, i) => (
            <Reveal className="wwd-item" tag="div" key={s.text} style={{ transitionDelay: `${(i % 2) * 0.06}s` }} data-testid={`wwd-item-${i}`}>
              <span className="wwd-ic" aria-hidden="true">{s.icon}</span>
              <span className="wwd-txt">{s.text}</span>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
